import { useContext, useEffect, useMemo, useState } from "react"
import { calculateWordsFromString, dateConvert } from "../../../utils/Helper";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { decryptData, encryptData } from "../../../utils/encrypt";

export const useOnetoOneNotes = ({ notesUser, setNotesFlag }) => {

    const { showSuccess, showInfo } = useContext(ToastContext);
    const [notesLoader, setNotesLoader] = useState({ btn: false, grid: false });
    const [notesRowData, setNotesRowData] = useState([]);
    const [notesData, setNotesData] = useState({ notes: "", user: {} });
    const [notesColDef] = useState([
        {
            field: "created_datetime",
            headerName: "Date",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && dateConvert(params?.value, "day-mon-year")}</div>
                )
            }
        },
        {
            field: "notes",
            headerName: "Note",
            flex: 4,
            cellRenderer: (params) => {
                const value = decryptData(params?.value)
                return (
                    <div title={value} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{value}</div>
                )
            }
        },
    ])

    useEffect(() => {
        getUserNotes(notesUser);
    }, [notesUser])

    const getUserNotes = async (callApi) => {
        try {
            if ((notesUser?.notes_count && notesUser?.notes_count > 0) || callApi) {
                setNotesLoader((prev) => ({ ...prev, grid: true }));
                const payload = {
                    requested_user_code: notesUser?.user_code
                }
                const res = await services.getInvokeRemote("POST", Urls("GETUSERNOTES"), payload);
                if (res) {
                    let data = res?.body?.data?.user_notes_list;
                    data = data.sort((a, b) => { return new Date(b?.created_datetime) - new Date(a?.created_datetime) });
                    setNotesRowData(data);
                    setNotesLoader((prev) => ({ ...prev, grid: false }));
                }
            } else {
                setNotesRowData([]);
            }
            setNotesData((prev) => ({ ...prev, user: notesUser, notes: "" }));
        } catch (error) {
            console.error("Error: ", error);
            setNotesLoader((prev) => ({ ...prev, grid: false }));
        }
    }

    const submitNotes = async () => {
        try {
            if (calculateWordsFromString(notesData?.notes) < 20) {
                showInfo("Info", "Please enter description of atleast 20 words");
                return;
            }
            setNotesLoader((prev) => ({ ...prev, btn: true }));
            const payload = {
                requested_user_code: notesData?.user?.user_code,
                notes: encryptData(notesData?.notes)
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVEUSERNOTES"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                getUserNotes(true);
                setNotesData((prev) => ({ ...prev, notes: "" }));
                setNotesFlag(true);
                setNotesLoader((prev) => ({ ...prev, btn: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setNotesLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    return useMemo(() => ({
        notesRowData, notesColDef, submitNotes, notesLoader, notesData, setNotesData
    }), [notesRowData, notesColDef, submitNotes, notesLoader, notesData, setNotesData])
}